import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-color-picker',
  templateUrl: './theme-color-picker.component.html',
  styleUrls: ['./theme-color-picker.component.scss']
})
export class ThemeColorPickerComponent implements OnInit {

  @Input() initTheme = '';

  @Output() selectedTheme: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  themes = [
    {
      name: 'Ventev Orange',
      theme: 'ventev-orange'
    },
    {
      name: 'Tessco Purple',
      theme: 'tessco-purple'
    },
    {
      name: 'Dusk Blue',
      theme: 'dusk-blue'
    },
    {
      name: 'Beautiful Salmon',
      theme: 'beautiful-salmon'
    },
    {
      name: 'Calming Grey',
      theme: 'calming-grey'
    },
    {
      name: 'Bright Peacock',
      theme: 'bright-peacock'
    },
    {
      name: 'Brilliant Blue',
      theme: 'brilliant-blue'
    },
    {
      name: 'Almost Black',
      theme: 'almost-black'
    }
  ];
  themeSelected = '';

  setTheme(theme) {
    this.themeSelected = theme;
    this.selectedTheme.emit(theme);
  }

  getName(theme) {
    return theme.name.replace(/ /g, '');
  }

  ngOnInit() {
    this.themeSelected = this.initTheme;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/theme-color-picker/theme-color-picker.component.ts